import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const role = this.authService.getUserRole();

    if (route.data && !route.data.roles.includes(role)) {
      let nextRoute = '/';
      this.router.navigate([nextRoute]);
      return false;
    }

    return true;
  }
}
